function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:#175664}\n        "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_7410",
  "data-name": "Group 7410",
  transform: "translate(8854.809 4294.5)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_7277",
  "data-name": "Group 7277",
  transform: "translate(-2076.309 -8685)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_2778",
  "data-name": "Path 2778",
  className: "cls-2",
  d: "M-25.969-6.532h-2.923a.959.959 0 0 1-.959-.959.959.959 0 0 1 .959-.959h2.923a.959.959 0 0 1 .959.959.959.959 0 0 1-.959.959z",
  transform: "translate(-6739.013 4413.868)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2779",
  "data-name": "Path 2779",
  className: "cls-2",
  d: "M-25.969-15.183h-2.923a.959.959 0 0 1-.959-.959.959.959 0 0 1 .959-.959h2.923a.959.959 0 0 1 .959.959.959.959 0 0 1-.959.959z",
  transform: "translate(-6739.013 4413.868)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2780",
  "data-name": "Path 2780",
  className: "cls-2",
  d: "M-18.848-2.265h-17.165a1.475 1.475 0 0 1-1.474-1.473v-16.156a1.475 1.475 0 0 1 1.474-1.474h17.165a1.475 1.475 0 0 1 1.474 1.474v16.156a1.475 1.475 0 0 1-1.474 1.473zM-35.57-4.182h16.279v-15.269H-35.57z",
  transform: "translate(-6739.013 4413.868)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2781",
  "data-name": "Path 2781",
  className: "cls-2",
  d: "M-18.333-10.858h-18.195a.958.958 0 0 1-.959-.958.959.959 0 0 1 .959-.959h18.195a.959.959 0 0 1 .959.959.958.958 0 0 1-.959.958z",
  transform: "translate(-6739.013 4413.868)"
})));

function SvgClinicDash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClinicDash);
export default __webpack_public_path__ + "static/media/clinicDash.982227ed.svg";
export { ForwardRef as ReactComponent };